"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ForgotSuccessSceneTranslation = {
    fi: {
        ForgotSuccessScene: {
            title: 'Salasanan nollauspyyntö lähetetty!',
            toLogin: 'Takaisin kirjautumissivulle',
            subTitle: 'Salasanan nollauslinkki on lähetetty sähköpostiisi! Avaa sähköpostissa oleva linkki ja vaihda salasana.',
        },
    },
    en: {
        ForgotSuccessScene: {
            title: 'Reset email is sent!',
            toLogin: 'Back to login',
            subTitle: 'Password reset link is sent to your email. Click link on your email and change password.',
        },
    },
};
exports.default = ForgotSuccessSceneTranslation;
//# sourceMappingURL=ForgotSuccessScene.translation.js.map